export const CardClients = {
  UBER: 'UBER_EGY',
  LUCKY: 'LUCKY_EGY',
  CONNECT_FF: 'CONNECT_FF_EGY',
  MOZARE: 'MOZARE3_EGY',
  UPPINGHAM: 'UPPINGHAM_EGY',
  BASATA: 'BASATA_EGY',
  MOZARE_DEMO: 'MOZARE3_EGY_FF',
  UPPINGHAM_DEMO: 'UPPINGHAM_EGY_FF',
  BASATA_DEMO: 'BASATA_EGY_FF',
  BANQUE_MISR_DEMO: 'BANQUE_MISR_EGY_FF',
};
